<template>
  <div v-if="user">
    <v-container v-if="user.memberType === 'free'" class="content-container">
      <div class="upgrade-required">
        You joined Pubby with a free Reader account which lets you earn snaps but doesn't let you add your own pulished books to request reviews. <br /> If you are ready to use Pubby as an Author to request reviews for your own books, you'll need upgrade to a paid subscription in your settings.
        <div class="upgrade-button" @click="clickSettings"> Subscription Page</div>
      </div>
    </v-container>
    <v-container v-else fluid class="content-container">
      <v-layout row wrap>
        <v-flex md12 xs12 sm12>
          <div v-if="isMobile" class="mobile-warning">
            While most features are available on your smarthphone, we recommend
            using Pubby on a
            <span class="mobile-strong">laptop or desktop computer</span> to
            access all features. You can visit
            <span class="mobile-strong">
              <a href="https://account.pubby.co">account.pubby.co</a>
            </span>
            from any device to log in.
          </div>

          <div class="heading then-cardlist heading-top">Your Books</div>

          <template v-if="books.length">
            <list :books="books"></list>
          </template>
          <template v-else>
            <div class="no-hero">
              <div class="icon">
                <img
                  src="/images/icons/author.svg"
                  alt="No Books"
                  class="icon-img"
                />
              </div>
              <div class="message">A new author? Awesome!</div>
              <div class="sub-message">
                You can add your first book here.
                <br />
                <br />If you don't have a book ready yet, you can click Reader
                on the left to start reviewing for more snaps!
              </div>
            </div>
          </template>

          <v-container grid-list-md fluid pa-0 class="table-container">
            <v-layout row wrap class="book-row">
              <v-flex xs12 sm12 md8 class="list-row">
                <div class="add-book-container">
                  <div
                    class="add-book grow"
                    @click="$router.push('/books/add')"
                  >
                    <div class="add-icon">
                      <i class="material-icons">add</i>
                    </div>
                    <div class="add-label">Add Book</div>
                  </div>
                </div>

                <pubby-picks
                  v-if="user.is_pubby_picks === 1"
                  user="user"
                ></pubby-picks>
              </v-flex>
              <v-flex md4 class="hidden-sm-and-down"></v-flex>
            </v-layout>
          </v-container>

          <!-- <div class="heading">Book Results</div> -->
          <!-- <review-chart></review-chart> -->
        </v-flex>

        <heads-down
          v-if="user.heads_down_at"
          :date="user.heads_down_at"
        ></heads-down>

        <v-flex md12 class="activity-col">
          <div class="heading then-cardlist align-with-top">Your Activity</div>
          <activity-timeline :events="events"></activity-timeline>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      v-if="user && user.id > 423 && user.id < 1055"
      fluid
      class="content-container content-challenges"
    >
      <v-layout row wrap>
        <v-flex md12 class="column-challenges">
          <div class="heading then-cardlist align-with-top">
            Your Challenges
          </div>
          <challenges></challenges>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Remove Powerup container for now
    <v-container v-if="user" fluid class="content-container content-challenges">
      <v-layout row wrap>
        <v-flex md12 class="column-challenges">
          <div class="heading then-cardlist align-with-top">Your Power Ups</div>
          <power-ups :user="user"></power-ups>
        </v-flex>
      </v-layout>
    </v-container> -->
    <v-container
      fluid
      class="content-container content-last hidden-sm-and-down"
    >
      <v-layout row wrap style="display: none">
        <v-flex md12>
          <div class="heading then-card">Review History</div>
          <template
            v-if="
              user &&
              user.authorStats.history_table &&
              typeof user.authorStats.history_table === 'object' &&
              !Array.isArray(user.authorStats.history_table)
            "
          >
            <results-table></results-table>
          </template>
          <template v-else>
            <div style="width: 80%">
              <no-content :half="true" icon="timeline"
                >Get your first review to see some stats!</no-content
              >
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <find-book></find-book> -->
  </div>
</template>

<script>
import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import List from "@/components/Book/List";
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import FindBook from "@/components/Page/FindBook";
import ActivityTimeline from "@/components/Activity/Timeline";
import ReviewChart from "@/components/Book/ReviewChart";
import ResultsTable from "@/components/Book/ResultsTable";
import NoContent from "@/components/Page/NoContent";
import Challenges from "@/components/Challenges/Challenges";
import PowerUps from "@/components/PowerUps/PowerUps";
import HeadsDown from "@/components/Page/HeadsDown";
import { mapState } from "vuex";

export default {
  name: "Page",
  components: {
    Head,
    Heading,
    list: List,
    FindBook,
    ReviewChart,
    ResultsTable,
    Challenges,
    PowerUps,
    "activity-timeline": ActivityTimeline,
    NoContent,
    HeadsDown,
  },
  data: function () {
    return {
      hasLiveBook: false,
      isMobile: null,
    };
  },
  computed: {
    ...mapState({
      user: "user",
      books: "books",
      events: "events",
    }),
  },
  watch: {
    user(newValue, oldValue) {
      const user = newValue;
      var hasLiveBook = false;
      for (const book of this.books) {
        if (book.status === "Available") {
          hasLiveBook = true;
        }
      }
      this.hasLiveBook = hasLiveBook;
    },
  },
  async created() {
    this.isMobile = isMobile();
    // console.log("books", this.books);
    // this.events = await Back.activityEvents();
    // Bus.$on("BookUpped", async () => {
    //   this.books = await Back.books();
    //   this.events = await Back.activityEvents();
    // });

    if (this.books) {
      var hasLiveBook = false;
      for (const book of this.books) {
        if (book.status === "Available") {
          hasLiveBook = true;
        }
      }
      this.hasLiveBook = hasLiveBook;
    }
  },
  methods: {
    clickPublishButton() {
      this.$router.push("/publish");
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 300);
    },
    clickSettings() {
      window.location.href = process.env.VUE_APP_ACCOUNT_URL + "/settings#/subscription";
    },
  },
};

function isMobile() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
</script>

<style scoped lang="scss">
.content-container {
  max-width: 1000px !important;
  margin-left: 4px;
  border-bottom: 0;
}

.content-challenges {
  max-width: 100% !important;
  border-top: 2px solid #eee;
  //padding-top: 20px;
}
.column-challenges {
  max-width: 710px;
}

.section-divider {
  width: 100%;
  height: 40px;
}

.publish-button-icon {
  text-align: center;
  margin-top: 16px;
}
.publish-button-img {
  width: 64px;
}

.publish-label {
  margin-top: -8px;
  font-size: 13pt;
  font-weight: 600;
  color: #111;
  font-family: "Source Sans Pro";
  text-align: center;
}

.publish-button {
  display: block;
  margin: 0 auto;
  margin-top: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 200px;
  border-radius: 52px;
  border: 0px solid #ddd;
  cursor: pointer;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 52px;
  border-radius: 52px;
  border: 1px solid #ddd;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book:hover {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: scale(1.05);
}
.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.activity-col {
  padding-left: 2px;
  max-width: 710px;
  margin: 20px 0;
}

.upgrade-required {
  margin: 66px auto 0 auto;
  max-width: 800px;
  background: $color-blue;
  border-radius: 16px;
  font-size: 13pt;
  font-weight: 700;
  color: #fff;
  padding: 16px 20px;
  display: block;

  .upgrade-message {
    flex-grow: 1;
    padding-top: 8px;
  }

  .upgrade-button {
    flex-grow: 0;
    margin-top:.5em;
    min-width: 160px;
    margin-left: auto;
    background: #fff;
    color: lighten($color-blue, 10%);
    padding: 0.5em 1em 0.4em 1em;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .upgrade-button:hover {
    background: #fff;
    color: lighten($color-blue, 0%);
  }
}

@media (max-width: 1024px) {
  .add-book-container {
    padding-bottom: 20px;
  }

  .activity-col {
    padding-left: 0;
  }

  .upgrade-required {
    display: block;
    margin: 12px 16px 8px 16px;
  }
}

.mobile-warning {
  margin: 20px 0 12px 0;
  border: 2px solid #f3f3f3;
  border-radius: 8px;
  padding: 12px;
  color: $color-blue;
  font-family: $font-family;
  font-size: 12pt;
}
.mobile-strong {
  font-weight: 600;
}
</style>